var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtticusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 481,
    viewBox: "0 0 481 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 240.5,
    r: 240.5,
    fill: "url(#paint0_linear_2230_14138)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 356.943L161.179 382L241 176.059L208.428 92L102 356.943Z",
    fill: "#01D9C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379 356.943L319.956 382L208 92H272.986L379 356.943Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2230_14138",
    x1: -141.983,
    y1: 237.326,
    x2: 332.67,
    y2: 521.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#734ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E78E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtticusCircle);
export default __webpack_public_path__ + "static/media/atticus-circle.2f583969.svg";
export { ForwardRef as ReactComponent };